import styled from 'styled-components'
import { P } from 'common/typography'
import { parse, formatDistanceToNowStrict } from 'date-fns'
import { es } from 'date-fns/locale'

export const AuthorStyled = styled.div`
  display: flex;
  align-items: center;
  .author-name {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    color: var(--baseNeutral);
  }
  .author-avatar {
    border-radius: 50%;
    height: 48PX;
    width: 48PX;
    margin: 0 8px 0 0;
  }
  .author-date {
    line-height: 21px;
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: #8D9DAB;
  }
  .blog-info-separator {
    display: inline-block;
    border-radius: 50%;
    margin: 2px 6px;
    width: 5px;
    height: 5px;
    background: var(--textOpaque);
  }
  .author-container {
    padding: 2.5px 2.5px 2.5px 2.4px;
    width: 48px;
    height: 48px;
    background: linear-gradient(51.32deg, #FA057C 0%, #0704FE 100%, rgba(196, 196, 196, 0) 100%);
    margin-right: 8px;
    border-radius: 50%;
  }
`

export function parseDate(date) {
  const day = date.slice(0, 2)
  const month = date.slice(3, 5)
  const year = date.slice(6)
  const parsedDate = parse(`${year}-${month}-${day}`, 'yyyy-MM-dd', new Date())
  return formatDistanceToNowStrict(parsedDate, { locale: es })
}

function AuthorInfo({
  photo, name, date, duration,
}) {
  return (
    <>
      <div className="author-container">
        <img width="60" height="60" className="author-avatar" src={photo} alt={name} />
      </div>
      <div className="author-info">
        <P id="author-name" className="author-name" color="var(--secondary)">{name}</P>
        <P className="author-date">
          {'Hace '}
          {parseDate(date)}
          {duration > 0 && (
            <>
              <span className="blog-info-separator" />
              <span className="blog-duration">
                {duration}
                {' minutos de lectura'}
              </span>
            </>
          )}
        </P>
      </div>
    </>
  )
}

export default AuthorInfo
